<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title mb-0">Danh sách khách hàng tiềm năng</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="/">Dashboard</a>
              </li>
              <li class="breadcrumb-item active">
                Danh sách khách hàng tiềm năng
              </li>
            </ul>
          </div>
          <div class="col-auto float-right ml-auto">
            <a href="/danh-sach-cong-ty">
              <button class="btn btn-primary">
                <i class="fa fa-plus mr-1"></i> Thêm khách hàng tiềm năng
              </button>
            </a>
          </div>
          <!-- <div class="col-auto float-right ml-auto">
            <button class="btn btn-primary" @click="openAddModal">
              <i class="fa fa-plus mr-1"></i> Thêm khách hàng tiềm năng
            </button>
          </div> -->
        </div>
      </div>

      <!-- Filter -->
      <div class="card mb-4 shadow-sm border-0">
        <div class="card-body py-3">
          <div class="form-row">
            <div class="col-md-3 mb-2">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Tìm theo tên khách hàng tiềm năng..."
                v-model="searchName"
                @keyup.enter="applyFilter"
              />
            </div>

            <div class="col-md-3 mb-2">
              <select
                class="form-control form-control-sm"
                v-model="selectedIndustryId"
                @change="applyFilter"
              >
                <option value="">Tất cả ngành nghề</option>
                <option v-for="ind in industries" :key="ind.id" :value="ind.id">
                  {{ ind.name }}
                </option>
              </select>
            </div>

            <div class="col-md-3 mb-3">
              <select
                class="form-control form-control-sm"
                v-model="selectedProvince"
                @change="applyFilter"
              >
                <option value="">Tất cả tỉnh</option>
                <option v-for="prov in provinces" :key="prov" :value="prov">
                  {{ prov }}
                </option>
              </select>
            </div>

            <!-- Dropdown chọn cột + nút Lọc + Xuất Excel -->
            <div class="col-md-3 mb-3">
              <div class="dropdown w-100 mb-2">
                <button
                  class="btn btn-outline-secondary btn-sm dropdown-toggle w-100"
                  data-toggle="dropdown"
                >
                  Hiển thị cột
                </button>
                <div
                  class="dropdown-menu p-3"
                  style="max-height: 320px; overflow: auto; min-width: 260px"
                >
                  <div
                    class="form-check mb-2"
                    v-for="f in FIELD_DEFS"
                    :key="f.key"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'field-' + f.key"
                      :value="f.key"
                      v-model="selectedFieldList"
                    />
                    <label class="form-check-label" :for="'field-' + f.key">
                      {{ f.label }}
                    </label>
                  </div>

                  <div class="mt-2 d-flex justify-content-between">
                    <button
                      class="btn btn-sm btn-link px-0"
                      @click.prevent="selectAllFields"
                    >
                      Chọn tất cả
                    </button>
                    <button
                      class="btn btn-sm btn-link px-0"
                      @click.prevent="clearAllFields"
                    >
                      Bỏ hết
                    </button>
                  </div>
                </div>
              </div>

              <button
                class="btn btn-secondary btn-sm w-100"
                @click="applyFilter"
              >
                Lọc
              </button>

              <!-- Xuất Excel -->
              <div class="dropdown w-100 mt-2">
                <button
                  class="btn btn-success btn-sm dropdown-toggle w-100"
                  data-toggle="dropdown"
                  :disabled="exportLoading || VISIBLE_COLS.length === 0"
                >
                  <span
                    v-if="exportLoading"
                    class="spinner-border spinner-border-sm mr-1"
                  ></span>
                  Xuất Excel
                </button>
                <div class="dropdown-menu w-100">
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="exportExcel(false)"
                  >
                    Trang hiện tại
                  </a>
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="exportExcel(true)"
                  >
                    Toàn bộ (theo bộ lọc)
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- /form-row -->
        </div>
      </div>

      <!-- Table -->
      <div class="card shadow-sm border-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-light">
                <tr>
                  <th v-for="col in VISIBLE_COLS" :key="col.key">
                    {{ col.label }}
                  </th>
                  <th class="text-right" style="width: 120px">Hành động</th>
                </tr>
              </thead>

              <tbody v-if="loading">
                <tr>
                  <td
                    :colspan="VISIBLE_COLS.length + 1"
                    class="text-center py-4"
                  >
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </td>
                </tr>
              </tbody>

              <tbody v-else-if="companies.length === 0">
                <tr>
                  <td
                    :colspan="VISIBLE_COLS.length + 1"
                    class="text-center text-muted py-4"
                  >
                    Không có khách hàng nào.
                  </td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr v-for="c in companies" :key="c.maKH">
                  <td v-for="col in VISIBLE_COLS" :key="col.key">
                    <!-- Render industries (tags) -->
                    <template v-if="col.key === 'industries'">
                      <span
                        v-for="ind in c.industries || []"
                        :key="ind.id"
                        class="badge badge-info mr-1 mb-1"
                        >{{ ind.name }}</span
                      >
                    </template>

                    <!-- Status (badge) -->
                    <template v-else-if="col.key === 'status'">
                      <span
                        :class="
                          c.status === 1
                            ? 'badge badge-success'
                            : 'badge badge-warning'
                        "
                      >
                        {{ c.status === 1 ? "Đã chăm sóc" : "Chưa chăm sóc" }}
                      </span>
                    </template>

                    <!-- Các field khác -->
                    <template v-else>
                      <a
                        v-if="makeLink(c, col)"
                        :href="makeLink(c, col)"
                        target="_blank"
                        >{{ displayValue(c, col) }}</a
                      >
                      <span v-else>{{ displayValue(c, col) }}</span>
                    </template>
                  </td>

                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-warning mr-1"
                      title="Sửa"
                      @click="openEditModal(c)"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      title="Xóa"
                      @click="openDeleteModal(c.companyId)"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Pagination -->
        <div
          v-if="companies.length > 0"
          class="card-footer bg-white d-flex flex-column flex-md-row justify-content-between align-items-center"
        >
          <div class="mb-2 mb-md-0">
            <small class="text-muted">
              Đang hiển thị {{ companies.length }} trên tổng số
              {{ totalElements }} khách hàng tiềm năng.
            </small>
          </div>

          <nav class="d-flex justify-content-center">
            <ul
              class="pagination justify-content-center align-items-center mb-0"
            >
              <li class="page-item" :class="{ disabled: currentPage === 0 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(currentPage - 1)"
                  >Trước</a
                >
              </li>

              <li class="page-item mx-2 d-flex align-items-center">
                <input
                  type="number"
                  v-model.lazy="inputPage"
                  @keyup.enter="goToPage(inputPage - 1)"
                  class="form-control form-control-sm text-center"
                  style="width: 70px"
                />
                <span class="text-muted ml-2">/ {{ totalPages }}</span>
              </li>

              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages - 1 }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(currentPage + 1)"
                  >Sau</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>

      <!-- MODAL: Add/Edit Company -->
      <div
        class="modal fade"
        id="company_modal"
        tabindex="-1"
        ref="companyModal"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <form @submit.prevent="saveCompany">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{
                    isEditing
                      ? "Sửa khách hàng tiềm năng"
                      : "Thêm khách hàng tiềm năng mới"
                  }}
                </h5>
                <button type="button" class="close" data-dismiss="modal">
                  &times;
                </button>
              </div>

              <div class="modal-body row">
                <div class="col-md-6 form-group">
                  <label>Mã khách hàng *</label>
                  <input
                    v-model="currentCompany.maKH"
                    required
                    class="form-control"
                    :readonly="isEditing"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>ID Công ty *</label>
                  <input
                    v-model="currentCompany.companyIdGoc"
                    required
                    class="form-control"
                    :readonly="isEditing"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Tên *</label>
                  <input
                    v-model="currentCompany.name"
                    required
                    class="form-control"
                  />
                </div>

                <div class="col-md-6 form-group">
                  <label>Địa chỉ</label>
                  <input
                    v-model="currentCompany.address"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Điện thoại</label>
                  <input v-model="currentCompany.phone" class="form-control" />
                </div>
                <div class="col-md-6 form-group">
                  <label>Hotline</label>
                  <input
                    v-model="currentCompany.hotline"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    v-model="currentCompany.email"
                    class="form-control"
                    multiple
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Website</label>
                  <input
                    v-model="currentCompany.website"
                    class="form-control"
                  />
                </div>

                <div class="col-md-6 form-group">
                  <label>Ngành nghề</label>
                  <select
                    v-model="currentCompany.industryIds"
                    class="form-control"
                    multiple
                  >
                    <option
                      v-for="ind in industries"
                      :key="ind.id"
                      :value="ind.id"
                    >
                      {{ ind.name }}
                    </option>
                  </select>
                </div>

                <!-- <div class="col-md-6 form-group">
                  <label>Trạng thái</label>
                  <select
                    v-model.number="currentCompany.status"
                    class="form-control"
                  >
                    <option :value="0">Chưa chăm sóc</option>
                    <option :value="1">Đã chăm sóc</option>
                  </select>
                </div> -->

                <div class="col-md-6 form-group">
                  <label>Tỉnh</label>
                  <select
                    v-model="currentCompany.province"
                    class="form-control"
                  >
                    <option value="">-- Chọn tỉnh --</option>
                    <option v-for="prov in provinces" :key="prov" :value="prov">
                      {{ prov }}
                    </option>
                  </select>
                </div>

                <div class="col-md-6 form-group">
                  <label>Tên người liên hệ</label>
                  <input
                    v-model="currentCompany.tenNguoiLienHe"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Chức vụ</label>
                  <input v-model="currentCompany.chucVu" class="form-control" />
                </div>
                <div class="col-md-6 form-group">
                  <label>Di động</label>
                  <input v-model="currentCompany.diDong" class="form-control" />
                </div>
                <div class="col-md-6 form-group">
                  <label>Zalo/Mess</label>
                  <input
                    v-model="currentCompany.zaloOrMess"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Email liên hệ</label>
                  <input
                    type="email"
                    v-model="currentCompany.emailLienHe"
                    class="form-control"
                  />
                </div>

                <div class="col-md-6 form-group">
                  <label>MST</label>
                  <input v-model="currentCompany.mst" class="form-control" />
                </div>
                <div class="col-md-6 form-group">
                  <label>Năm thành lập</label>
                  <input
                    v-model="currentCompany.namThanhLap"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Loại hình kinh doanh</label>
                  <input
                    v-model="currentCompany.loaiHinhKinhDoanh"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Thị trường chính</label>
                  <input
                    v-model="currentCompany.thiTruongChinh"
                    class="form-control"
                  />
                </div>
                <div class="col-md-6 form-group">
                  <label>Số lượng nhân viên</label>
                  <input
                    v-model="currentCompany.soLuongNV"
                    class="form-control"
                  />
                </div>

                <div class="col-md-6 form-group">
                  <label>Ghi chú khách hàng</label>
                  <textarea
                    v-model="currentCompany.ghiChu"
                    class="form-control"
                    rows="4"
                  ></textarea>
                </div>
                <div class="col-md-6 form-group">
                  <label>Người phụ trách</label>
                  <input
                    v-model="currentCompany.nguoiPhuTrach"
                    class="form-control"
                    readonly
                  />
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn btn-primary" type="submit">
                  {{ isEditing ? "Lưu" : "Thêm" }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Hủy
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <!-- MODAL: Xóa -->
      <div
        class="modal fade"
        id="delete_company_modal"
        tabindex="-1"
        ref="deleteModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content text-center">
            <div class="modal-body">
              <h5>Bạn có chắc muốn xóa khách hàng tiềm năng này?</h5>
              <div class="mt-3">
                <button class="btn btn-danger mr-2" @click="deleteCompany">
                  Xóa
                </button>
                <button class="btn btn-secondary" data-dismiss="modal">
                  Hủy
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from "vue";
import { useToast } from "vue-toastification";
import api from "../api";
import { useAuthStore } from "@/stores/auth.js";
import * as XLSX from "xlsx";

const toast = useToast();
const authStore = useAuthStore();

const companies = ref([]);
const industries = ref([]);
const provinces = ref([]);

const selectedIndustryId = ref("");
const selectedStatus = ref("");
const selectedProvince = ref("");
const searchName = ref("");
const loading = ref(true);
const exportLoading = ref(false);

const currentPage = ref(0);
const pageSize = ref(12);
const totalElements = ref(0);
const totalPages = ref(0);

const inputPage = ref(1);

const currentCompany = reactive({
  maKH: "",
  companyIdGoc: "",
  name: "",
  address: "",
  phone: "",
  hotline: "",
  email: "",
  website: "",
  industryIds: [],
  status: 0,
  province: "",
  tenNguoiLienHe: "",
  chucVu: "",
  diDong: "",
  zaloOrMess: "",
  emailLienHe: "",
  mst: "",
  namThanhLap: "",
  loaiHinhKinhDoanh: "",
  thiTruongChinh: "",
  soLuongNV: "",
  nguoiPhuTrach: "",
  ghiChu: "",
});

const isEditing = ref(false);
const companyToDeleteId = ref(null);

const companyModal = ref(null);
const deleteModal = ref(null);

const showModal = (modalRef) => {
  $(modalRef.value).modal("show");
};
const hideModal = (modalRef) => {
  $(modalRef.value).modal("hide");
};

/** ================== CẤU HÌNH CỘT (TABLE) ================== */
const FIELD_DEFS = [
  { key: "maKH", label: "Mã khách hàng", render: (c) => c.maKH },
  {
    key: "companyIdGoc",
    label: "Mã công ty (ID)",
    render: (c) => c.companyIdGoc,
  },
  { key: "name", label: "Tên công ty khách hàng", render: (c) => c.name },
  { key: "address", label: "Địa chỉ", render: (c) => c.address },
  { key: "province", label: "Tỉnh/TP", render: (c) => c.province },
  {
    key: "phone",
    label: "Điện thoại",
    render: (c) => c.phone,
    link: (c) => (c.phone ? `tel:${c.phone}` : null),
  },
  {
    key: "hotline",
    label: "Zalo",
    render: (c) => c.hotline,
    link: (c) =>
      c.hotline
        ? `https://zalo.me/${String(c.hotline).replace(/\s+/g, "")}`
        : null,
  },
  {
    key: "email",
    label: "Email",
    render: (c) => c.email,
    link: (c) => (c.email ? `mailto:${c.email}` : null),
  },
  {
    key: "website",
    label: "Website",
    render: (c) => c.website,
    link: (c) =>
      c.website
        ? /^https?:\/\//i.test(c.website)
          ? c.website
          : `http://${c.website}`
        : null,
  },
  {
    key: "tenNguoiLienHe",
    label: "Người liên hệ",
    render: (c) => {
      const parts = [c.tenNguoiLienHe, c.chucVu ? `(${c.chucVu})` : ""].filter(
        Boolean
      );
      return parts.join(" ");
    },
  },
  {
    key: "diDong",
    label: "Di động",
    render: (c) => c.diDong,
    link: (c) => (c.diDong ? `tel:${c.diDong}` : null),
  },
  {
    key: "emailLienHe",
    label: "Email liên hệ",
    render: (c) => c.emailLienHe,
    link: (c) => (c.emailLienHe ? `mailto:${c.emailLienHe}` : null),
  },
  { key: "mst", label: "MST", render: (c) => c.mst },
  { key: "namThanhLap", label: "Năm thành lập", render: (c) => c.namThanhLap },
  {
    key: "loaiHinhKinhDoanh",
    label: "Loại hình",
    render: (c) => c.loaiHinhKinhDoanh,
  },
  {
    key: "thiTruongChinh",
    label: "Thị trường chính",
    render: (c) => c.thiTruongChinh,
  },
  { key: "soLuongNV", label: "Số NV", render: (c) => c.soLuongNV },
  {
    key: "nguoiPhuTrach",
    label: "Người phụ trách",
    render: (c) => c.nguoiPhuTrach,
  },
  {
    key: "ngayTao",
    label: "Ngày chăm sóc",
    render: (c) => {
      if (!c.ngayTao) return null;

      try {
        const date = new Date(c.ngayTao);
        return date
          .toLocaleString("vi-VN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
          })
          .replace(",", "");
      } catch (error) {
        return c.ngayTao;
      }
    },
  },
  {
    key: "industries",
    label: "Ngành nghề",
    render: (c) => (c.industries && c.industries.length ? c.industries : null),
  },
];

// mặc định: tên, điện thoại, email
const DEFAULT_FIELDS = ["name", "phone", "email"];
const LS_KEY = "potential.customers.selectedFields.table";

const selectedFieldList = ref([]);
try {
  const saved = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
  selectedFieldList.value =
    Array.isArray(saved) && saved.length ? saved : DEFAULT_FIELDS.slice();
} catch {
  selectedFieldList.value = DEFAULT_FIELDS.slice();
}

const selectedFieldsSet = computed(() => new Set(selectedFieldList.value));

// Cột hiển thị theo thứ tự FIELD_DEFS
const VISIBLE_COLS = computed(() =>
  FIELD_DEFS.filter((f) => selectedFieldsSet.value.has(f.key))
);

// helper render
const displayValue = (company, fieldDef) => {
  const val =
    typeof fieldDef.render === "function"
      ? fieldDef.render(company)
      : company[fieldDef.key];
  if (fieldDef.key === "industries") return val && val.length ? val : null;
  if (val === undefined || val === null) return null;
  const s = String(val).trim();
  return s.length ? s : null;
};

const makeLink = (company, fieldDef) => {
  if (typeof fieldDef.link === "function") {
    const href = fieldDef.link(company);
    return href && String(href).trim().length ? href : null;
  }
  return null;
};

const selectAllFields = () => {
  selectedFieldList.value = FIELD_DEFS.map((f) => f.key);
};
const clearAllFields = () => {
  selectedFieldList.value = [];
};

watch(
  selectedFieldList,
  (val) => {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(val));
    } catch {}
  },
  { deep: true }
);
/** ================== HẾT CẤU HÌNH CỘT ================== */

const fetchIndustries = async () => {
  try {
    const res = await api.get("/api/industries", {
      params: { page: 0, size: 100 },
    });
    industries.value = res.data.content;
  } catch {
    toast.error("Không thể tải ngành nghề");
  }
};

const fetchProvinces = async () => {
  try {
    const res = await api.get("/api/companies/provinces");
    provinces.value = res.data;
  } catch {
    toast.error("Không thể tải danh sách tỉnh");
  }
};

const buildFilterParams = (page, size) => {
  const params = { page, size };
  if (selectedIndustryId.value)
    params.industryId = Number(selectedIndustryId.value);
  if (selectedStatus.value !== "") params.status = selectedStatus.value;
  if (searchName.value) params.name = searchName.value;
  if (selectedProvince.value) params.province = selectedProvince.value;
  return params;
};

const normalizeCompany = (c) => ({
  ...c,
  industries: c.industries || [],
  status: c.status ?? 0,
  province: c.province || "",
  tenNguoiLienHe: c.tenNguoiLienHe || "",
  chucVu: c.chucVu || "",
  diDong: c.diDong || "",
  zaloOrMess: c.zaloOrMess || "",
  emailLienHe: c.emailLienHe || "",
  mst: c.mst || "",
  namThanhLap: c.namThanhLap || "",
  loaiHinhKinhDoanh: c.loaiHinhKinhDoanh || "",
  thiTruongChinh: c.thiTruongChinh || "",
  soLuongNV: c.soLuongNV || "",
  nguoiPhuTrach: c.nguoiPhuTrach.hoTen || "",
});

const fetchCompanies = async () => {
  loading.value = true;
  try {
    const res = await api.get("/api/khach-hang-tiem-nang", {
      params: buildFilterParams(currentPage.value, pageSize.value),
    });
    companies.value = (res.data.content || []).map(normalizeCompany);
    totalElements.value = res.data.totalElements;
    totalPages.value = res.data.totalPages;
  } catch {
    toast.error("Không thể tải danh sách khách hàng");
  } finally {
    loading.value = false;
  }
};

// Lấy toàn bộ theo bộ lọc (gộp nhiều trang)
const fetchAllCompaniesWithCurrentFilters = async (sizePerPage = 1000) => {
  let page = 0;
  let results = [];
  let pages = 1;
  try {
    do {
      const res = await api.get("/api/khach-hang-tiem-nang", {
        params: buildFilterParams(page, sizePerPage),
      });
      const content = (res.data.content || []).map(normalizeCompany);
      results = results.concat(content);
      pages = res.data.totalPages ?? 1;
      page++;
    } while (page < pages);
  } catch (e) {
    console.error("fetchAllCompaniesWithCurrentFilters error", e);
  }
  return results;
};

const applyFilter = () => {
  currentPage.value = 0;
  fetchCompanies();
};

const goToPage = (page) => {
  const pageNumber = typeof page === "number" ? page : parseInt(page);
  if (!isNaN(pageNumber) && pageNumber >= 0 && pageNumber < totalPages.value) {
    currentPage.value = pageNumber;
    fetchCompanies();
  } else {
    toast.error(
      `Số trang không hợp lệ. Vui lòng nhập số từ 1 đến ${totalPages.value}`
    );
  }
};

const openAddModal = () => {
  isEditing.value = false;
  Object.assign(currentCompany, {
    maKH: "",
    companyIdGoc: "",
    name: "",
    address: "",
    phone: "",
    hotline: "",
    email: "",
    website: "",
    industryIds: [],
    status: 0,
    province: "",
    tenNguoiLienHe: "",
    chucVu: "",
    diDong: "",
    zaloOrMess: "",
    emailLienHe: "",
    mst: "",
    namThanhLap: "",
    loaiHinhKinhDoanh: "",
    thiTruongChinh: "",
    soLuongNV: "",
    nguoiPhuTrach: "",
    ghichu: "",
  });
  showModal(companyModal);
};

const openEditModal = (company) => {
  isEditing.value = true;
  Object.assign(currentCompany, {
    maKH: company.maKH,
    companyIdGoc: company.companyIdGoc,
    name: company.name,
    address: company.address,
    phone: company.phone,
    hotline: company.hotline,
    email: company.email,
    website: company.website,
    industryIds: (company.industries || [])
      .map((i) => Number(i.id))
      .filter((id) => !isNaN(id)),
    status: company.status,
    province: company.province || "",
    tenNguoiLienHe: company.tenNguoiLienHe || "",
    chucVu: company.chucVu || "",
    diDong: company.diDong || "",
    zaloOrMess: company.zaloOrMess || "",
    emailLienHe: company.emailLienHe || "",
    mst: company.mst || "",
    namThanhLap: company.namThanhLap || "",
    loaiHinhKinhDoanh: company.loaiHinhKinhDoanh || "",
    thiTruongChinh: company.thiTruongChinh || "",
    soLuongNV: company.soLuongNV || "",
    ghiChu: company.ghiChu || "",
    nguoiPhuTrach: company.nguoiPhuTrach || "Không rõ",
    ghichu: company.ghichu || "",
  });
  showModal(companyModal);
};

const saveCompany = async () => {
  try {
    const payload = {
      ...currentCompany,
      industries: currentCompany.industryIds.map((id) => ({ id })),
    };

    if (isEditing.value) {
      await api.put(`/api/khach-hang-tiem-nang/${payload.maKH}`, payload);
    } else {
      await api.post("/api/khach-hang-tiem-nang", payload);
    }

    toast.success(
      isEditing.value ? "Cập nhật thành công" : "Thêm khách hàng thành công"
    );
    hideModal(companyModal);
    fetchCompanies();
  } catch (error) {
    console.error("Lỗi khi lưu khách hàng:", error);
    toast.error("Lỗi khi lưu khách hàng. Vui lòng kiểm tra lại dữ liệu.");
  }
};

const openDeleteModal = (id) => {
  companyToDeleteId.value = id;
  showModal(deleteModal);
};

const deleteCompany = async () => {
  try {
    await api.delete(`/api/khach-hang-tiem-nang/${companyToDeleteId.value}`);
    toast.success("Xóa thành công");
    hideModal(deleteModal);
    fetchCompanies();
  } catch {
    toast.error("Lỗi khi xóa");
  }
};

onMounted(() => {
  fetchIndustries();
  fetchProvinces();
  fetchCompanies();
});

watch(currentPage, (newPage) => {
  inputPage.value = newPage + 1;
});

watch(
  () => authStore.user,
  (newUser) => {
    if (newUser && !isEditing.value) {
      currentCompany.nguoiPhuTrach || "Không rõ";
    }
  },
  { immediate: true }
);

/** ================== XUẤT EXCEL ================== */
const buildRowsForExport = (data) => {
  const rows = data.map((c) => {
    const row = {};
    VISIBLE_COLS.value.forEach((col) => {
      if (col.key === "industries") {
        row[col.label] =
          Array.isArray(c.industries) && c.industries.length
            ? c.industries.map((i) => i.name).join(", ")
            : "";
      } else if (col.key === "status") {
        row[col.label] = c.status === 1 ? "Đã chăm sóc" : "Chưa chăm sóc";
      } else {
        row[col.label] = displayValue(c, col) ?? "";
      }
    });
    return row;
  });
  return rows;
};

const formatFilename = (prefix = "companies") => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${prefix}_${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(
    d.getDate()
  )}_${pad(d.getHours())}${pad(d.getMinutes())}.xlsx`;
};

/**
 * Xuất Excel
 * @param {boolean} all - true: xuất toàn bộ theo bộ lọc (gọi nhiều trang), false: chỉ trang hiện tại
 */
const exportExcel = async (all = false) => {
  try {
    if (VISIBLE_COLS.value.length === 0) {
      toast.error("Bạn chưa chọn cột hiển thị để xuất.");
      return;
    }

    exportLoading.value = true;

    // Lấy data
    let data = [];
    if (all) {
      data = await fetchAllCompaniesWithCurrentFilters(1000);
    } else {
      data = companies.value.slice();
    }

    if (!data.length) {
      toast.info("Không có dữ liệu để xuất.");
      return;
    }

    const rows = buildRowsForExport(data);

    // Tạo file Excel bằng SheetJS
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(rows);
    XLSX.utils.book_append_sheet(wb, ws, "Companies");
    const fileName = formatFilename(all ? "companies_all" : "companies_page");
    XLSX.writeFile(wb, fileName);

    toast.success(`Đã xuất ${rows.length} dòng ra tệp ${fileName}`);
  } catch (e) {
    console.error("exportExcel error", e);
    toast.error("Xuất Excel thất bại. Hãy thử lại hoặc kiểm tra console.");
  } finally {
    exportLoading.value = false;
  }
};
/** ================== HẾT: XUẤT EXCEL ================== */
</script>

<style scoped>
/* Filter card nhỏ gọn */
.card-body .form-row .form-control-sm {
  height: 34px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
}

/* Table */
.table thead th {
  white-space: nowrap;
}
.table td,
.table th {
  vertical-align: middle;
}

/* Badge trạng thái */
.badge-warning {
  background-color: #ffc107;
  color: #212529;
}
.badge-success {
  background-color: #28a745;
}

/* Industries badges */
.badge-info {
  background-color: #17a2b8;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.3em 0.5em;
  border-radius: 5px;
}

/* Dropdown Hiển thị */
.dropdown-menu .form-check {
  white-space: nowrap;
}

/* Pagination responsive */
.pagination .page-item .page-link {
  padding: 0.375rem 0.625rem;
}
.card-footer .pagination {
  margin-bottom: 0;
}

/* Modal responsive */
@media (max-width: 576px) {
  .modal-dialog {
    margin: 0.5rem;
  }
  .modal-dialog.modal-lg {
    max-width: 95%;
  }
  .modal-body.row > div {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
